import { useAuth } from '../auth/AuthProvider';
import CrowLogo from '../brand/CrowLogo';
import { Bell, LogOut } from 'lucide-react';

export default function TopBar() {
  const { user, logout } = useAuth();

  return (
    <header
      className="
        sticky top-0 z-20 flex items-center justify-between
        h-16 px-4 lg:px-6 border-b border-border-default
        bg-surface-card
      "
    >
      {/* Mobile: Logo / Desktop: spacer */}
      <div className="lg:hidden">
        <CrowLogo height={26} />
      </div>
      <div className="hidden lg:block" />

      {/* Right side actions */}
      <div className="flex items-center gap-2">
        <button
          className="
            min-w-touch min-h-touch flex items-center justify-center rounded-control
            text-ink-muted hover:bg-surface-sunken hover:text-ink transition-colors duration-state
          "
          aria-label="Notifications"
        >
          <Bell size={20} strokeWidth={1.5} />
        </button>

        <div className="hidden sm:flex items-center gap-2 px-3 py-2 rounded-control text-ink-soft">
          <div className="w-8 h-8 rounded-pill bg-accent text-white text-small font-semibold flex items-center justify-center">
            {user?.full_name?.[0]?.toUpperCase() || user?.email?.[0]?.toUpperCase() || '?'}
          </div>
          <span className="text-body-strong max-w-[120px] truncate">
            {user?.full_name || user?.email}
          </span>
        </div>

        <button
          onClick={logout}
          className="
            min-w-touch min-h-touch flex items-center justify-center rounded-control
            text-ink-muted hover:bg-surface-sunken hover:text-ink transition-colors duration-state
          "
          aria-label="Log out"
        >
          <LogOut size={20} strokeWidth={1.5} />
        </button>
      </div>
    </header>
  );
}
